// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"b6024c04","23":"ec4d3dd1","360":"3757e024","364":"b093d226","612":"08e52dee","621":"0157068f","656":"048a7b3a","695":"adbbba74","961":"91113ea4"}[chunkId] + ".chunk.js";
};